<template>
  <div class="uyh-text-design-container">
    <div class="uyh-back">
      <router-link to="/pick-a-mantra/text">
        <svg svg-inline="" class="uyh-back-arrow js-back" role="presentation" focusable="false" width="19" height="30" viewBox="0 0 19 30" xmlns="http://www.w3.org/2000/svg"><path d="M15.882 30L0 15 15.882 0l3.065 2.896L6.131 15l12.816 12.103z" fill="#21362C" fill-rule="evenodd"/></svg><span>{{ $t('navigation.back') }}</span>
      </router-link>
    </div>

    <div v-if="(['1','2','3','4']).indexOf(mantraid) > -1" class="uyh-background primary" :style="[getBackground(getStore.primarybackground)]" :class="[tempId(mantraid)]">
      <div class="uyh-background secondary" :style="[getBackground(getStore.secondarybackground)]"></div>
      <div class="uyh-background textarea" :style="[getBackground(getStore.textareacolor)]" :class="[getStore.textareaborder]">
        <p v-if="getStore.hashtag != ''" class="uyh-hashtag" :style="{color: getStore.textcolor}">{{ $t('mantras.hashtags.' + getStore.hashtag) }}</p>
        <h1 :class="getStore.textstyle" :style="{color: getStore.textcolor}" v-html="$t('mantras.messages.text.' + getStore.message)"></h1>
        <svg v-if="getStore.icon == 'true'" svg-inline="" :style="{fill: getStore.textcolor}" role="presentation" focusable="false" width="34" height="32" viewBox="0 0 34 32" xmlns="http://www.w3.org/2000/svg"><path d="M12.32 24.995v-.34c0-.766.242-1.467 1.11-3.114l2.147-4.065-.526-.255c-.854 1.248-2.248 3.552-5.176 3.55C7.002 20.769 5 18.51 5 15.523c.002-2.844 2.023-5.031 4.653-7.205l7.194-5.983h.285l7.191 5.988c2.63 2.176 4.675 4.34 4.674 7.182-.002 2.984-2.032 5.273-4.905 5.273-2.93-.002-4.325-2.306-5.177-3.556l-.523.254 2.145 4.068c.865 1.647 1.107 2.349 1.107 3.115V25l-9.324-.005" fill-rule="evenodd"/></svg>
      </div>
    </div>

    <div v-else-if="(['5','6','7']).indexOf(mantraid) > -1" class="uyh-background primary" :style="[getBackground(getStore.primarybackground)]" :class="[tempId(mantraid)]">
      <div class="uyh-background textarea">
        <p v-if="getStore.hashtag != ''" class="uyh-hashtag" :style="{color: getStore.textcolor}">{{ $t('mantras.hashtags.' + getStore.hashtag) }}</p>
        <h1 :class="getStore.textstyle" :style="{color: getStore.textcolor}" v-html="$t('mantras.messages.text.' + getStore.message)"></h1>
        <svg v-if="getStore.icon == 'true'" svg-inline="" :style="{fill: getStore.textcolor}" role="presentation" focusable="false" width="34" height="32" viewBox="0 0 34 32" xmlns="http://www.w3.org/2000/svg"><path d="M12.32 24.995v-.34c0-.766.242-1.467 1.11-3.114l2.147-4.065-.526-.255c-.854 1.248-2.248 3.552-5.176 3.55C7.002 20.769 5 18.51 5 15.523c.002-2.844 2.023-5.031 4.653-7.205l7.194-5.983h.285l7.191 5.988c2.63 2.176 4.675 4.34 4.674 7.182-.002 2.984-2.032 5.273-4.905 5.273-2.93-.002-4.325-2.306-5.177-3.556l-.523.254 2.145 4.068c.865 1.647 1.107 2.349 1.107 3.115V25l-9.324-.005" fill-rule="evenodd"/></svg>
      </div>
    </div>

    <div v-else-if="(['8']).indexOf(mantraid) > -1" class="uyh-background primary" :style="[getBackground(getStore.primarybackground)]" :class="[tempId(mantraid)]">
      <p v-if="getStore.hashtag != ''" class="uyh-hashtag" :style="{color: getStore.textcolor}">{{ $t('mantras.hashtags.' + getStore.hashtag) }}</p>
      <div class="uyh-background textarea" :style="[getBackground(getStore.textareacolor)]" :class="[getStore.textareaborder]">
        <div class="message-wrapper">
          <h1 :class="getStore.textstyle" :style="{color: getStore.textcolor}" v-html="$t('mantras.messages.text.' + getStore.message)"></h1>
        </div>
      </div>
      <svg v-if="getStore.icon == 'true'" svg-inline="" :style="{fill: getStore.textcolor}" role="presentation" focusable="false" width="34" height="32" viewBox="0 0 34 32" xmlns="http://www.w3.org/2000/svg"><path d="M12.32 24.995v-.34c0-.766.242-1.467 1.11-3.114l2.147-4.065-.526-.255c-.854 1.248-2.248 3.552-5.176 3.55C7.002 20.769 5 18.51 5 15.523c.002-2.844 2.023-5.031 4.653-7.205l7.194-5.983h.285l7.191 5.988c2.63 2.176 4.675 4.34 4.674 7.182-.002 2.984-2.032 5.273-4.905 5.273-2.93-.002-4.325-2.306-5.177-3.556l-.523.254 2.145 4.068c.865 1.647 1.107 2.349 1.107 3.115V25l-9.324-.005" fill-rule="evenodd"/></svg>
    </div>

    <div v-else-if="(['9','10']).indexOf(mantraid) > -1" class="uyh-background primary" :style="[getBackground(getStore.primarybackground)]" :class="[tempId(mantraid)]">
      <div class="uyh-background textarea alt-2" :style="[getBackground(getStore.textareacolor)]" :class="[getStore.textareaborder]">
        <div class="message-wrapper">
          <p v-if="getStore.hashtag != ''" class="uyh-hashtag" :style="{color: getStore.textcolor}">{{ $t('mantras.hashtags.' + getStore.hashtag) }}</p>
          <h1 :class="getStore.textstyle" :style="{color: getStore.textcolor}" v-html="$t('mantras.messages.text.' + getStore.message)"></h1>
          <svg v-if="getStore.icon == 'true'" svg-inline="" :style="{fill: getStore.textcolor}" role="presentation" focusable="false" width="34" height="32" viewBox="0 0 34 32" xmlns="http://www.w3.org/2000/svg"><path d="M12.32 24.995v-.34c0-.766.242-1.467 1.11-3.114l2.147-4.065-.526-.255c-.854 1.248-2.248 3.552-5.176 3.55C7.002 20.769 5 18.51 5 15.523c.002-2.844 2.023-5.031 4.653-7.205l7.194-5.983h.285l7.191 5.988c2.63 2.176 4.675 4.34 4.674 7.182-.002 2.984-2.032 5.273-4.905 5.273-2.93-.002-4.325-2.306-5.177-3.556l-.523.254 2.145 4.068c.865 1.647 1.107 2.349 1.107 3.115V25l-9.324-.005" fill-rule="evenodd"/></svg>
        </div>
      </div>
    </div>

    <div v-else-if="(['11']).indexOf(mantraid) > -1" class="uyh-background primary" :style="[getBackground(getStore.primarybackground)]" :class="[tempId(mantraid)]">
      <div class="uyh-background secondary" :style="[getBackground(getStore.secondarybackground)]"></div>
      <div class="uyh-background textarea">
        <p v-if="getStore.hashtag" class="uyh-hashtag" :style="{color: getStore.textcolor}">{{ $t('mantras.hashtags.' + getStore.hashtag) }}</p>
        <svg svg-inline="" :style="{fill: getStore.textareacolor}" class="large-spade" role="presentation" focusable="false" width="328" height="310" viewBox="0 0 328 310" xmlns="http://www.w3.org/2000/svg"><path d="M101.784 302.86v-4.486c0-10.128 3.198-19.395 14.672-41.168l28.414-53.72-6.962-3.376c-11.293 16.494-29.729 46.946-68.46 46.923-38.007-.023-64.493-29.885-64.493-69.354.023-37.588 26.758-66.498 61.544-95.227l95.174-79.074h3.765l95.128 79.142c34.786 28.752 61.84 57.345 61.817 94.91-.023 39.446-26.872 69.693-64.878 69.693-38.754-.022-57.213-30.473-68.484-46.99l-6.916 3.353 28.369 53.765c11.451 21.774 14.649 31.04 14.649 41.168v4.509l-123.339-.068" fill-rule="evenodd"/></svg>
        <h1 :class="getStore.textstyle" :style="{color: getStore.textcolor}" v-html="$t('mantras.messages.text.' + getStore.message)"></h1>
      </div>
      <svg v-if="getStore.icon == 'true'" svg-inline="" :style="{fill: getStore.textareacolor}" class="icon" role="presentation" focusable="false" width="34" height="32" viewBox="0 0 34 32" xmlns="http://www.w3.org/2000/svg"><path d="M12.32 24.995v-.34c0-.766.242-1.467 1.11-3.114l2.147-4.065-.526-.255c-.854 1.248-2.248 3.552-5.176 3.55C7.002 20.769 5 18.51 5 15.523c.002-2.844 2.023-5.031 4.653-7.205l7.194-5.983h.285l7.191 5.988c2.63 2.176 4.675 4.34 4.674 7.182-.002 2.984-2.032 5.273-4.905 5.273-2.93-.002-4.325-2.306-5.177-3.556l-.523.254 2.145 4.068c.865 1.647 1.107 2.349 1.107 3.115V25l-9.324-.005" fill-rule="evenodd"/></svg>
    </div>

    <div v-else-if="(['12']).indexOf(mantraid) > -1" class="uyh-background primary" :style="[getBackground(getStore.primarybackground)]" :class="[tempId(mantraid)]">
      <div class="uyh-background secondary" :style="[getBackground(getStore.secondarybackground)]"></div>
      <div class="uyh-background textarea">
        <p v-if="getStore.hashtag" class="uyh-hashtag" :style="{color: getStore.textcolor}">{{ $t('mantras.hashtags.' + getStore.hashtag) }}</p>
        <h1 :class="getStore.textstyle" :style="{color: getStore.textcolor}" v-html="$t('mantras.messages.text.' + getStore.message)"></h1>
        <svg v-if="getStore.icon == 'true'" svg-inline="" :style="{fill: getStore.textcolor}" class="icon" role="presentation" focusable="false" width="34" height="32" viewBox="0 0 34 32" xmlns="http://www.w3.org/2000/svg"><path d="M12.32 24.995v-.34c0-.766.242-1.467 1.11-3.114l2.147-4.065-.526-.255c-.854 1.248-2.248 3.552-5.176 3.55C7.002 20.769 5 18.51 5 15.523c.002-2.844 2.023-5.031 4.653-7.205l7.194-5.983h.285l7.191 5.988c2.63 2.176 4.675 4.34 4.674 7.182-.002 2.984-2.032 5.273-4.905 5.273-2.93-.002-4.325-2.306-5.177-3.556l-.523.254 2.145 4.068c.865 1.647 1.107 2.349 1.107 3.115V25l-9.324-.005" fill-rule="evenodd"/></svg>
      </div>
    </div>

    <div class="uyh-additional-controls" v-if="windowWidth > 1023">
      <div tabindex="0" @click="$emit('reset')" class="resetMantra" :class='{disabled: resetStatus}'>{{ $t('navigation.reset') }}</div>
      <button @click="emitEvents" class="uyh-btn">{{ $t('navigation.next') }}</button>
    </div>
  </div>
</template>


<script>
  const rootHost = process.env.BASE_URL;

  export default {
    props: ['resetStatus'],
    data: function() {
      return {
        windowWidth: 0,
        mantraid: this.$route.params.mantraId
      }
    },
    methods: {
      widowWidth: function() {
        this.windowWidth = window.innerWidth;
      },
      tempId: function(mantraId) {
        return 'temp-' + mantraId.toString();
      },
      getBackground: function(backgroundData) {
        if (backgroundData.includes('patterns')) {
          if (backgroundData.includes('_Swatch')) {
            backgroundData = backgroundData.replace('_Swatch', '_640X640');
          }
          return { backgroundImage: 'url(' + rootHost + backgroundData + ')' }
        } else {
          return { background: backgroundData }
        }
      },
      emitEvents: function() {
        this.$emit('screenshot');
        this.$emit('loader-active');
      }
    },
    computed: {
      getStore() {
        return {
          primarybackground: this.$store.state.primarybackground,
          secondarybackground: this.$store.state.secondarybackground,
          textareacolor: this.$store.state.textareacolor,
          textcolor: this.$store.state.textcolor,
          textstyle: this.$store.state.textstyle,
          textareaborder: this.$store.state.textareaborder,
          message: this.$store.state.message,
          hashtag: this.$store.state.hashtag,
          icon: this.$store.state.icon,
          options: this.$store.state.options
        }
      }
    },
    mounted: function() {
      this.$nextTick(function() {
        window.addEventListener('resize', this.widowWidth);
        this.widowWidth();
      });
    },
    destroyed: function() {
      document.removeEventListener('resize', this.widowWidth);
    }
  }
</script>

<style lang="scss" scoped>
  .responsivesite #wrapper #uyh-app,
  #uyh-app {
    $mobile-breakpoint: 767px;
    $tablet-portrait-down-breakpoint: 1023px;
    $tablet-portrait-breakpoint: 1024px;
    $tablet-down-breakpoint: 1199px;
    $hd-desktop-breakpoint: 1280px;


    .mediumweight {
      font-weight: normal;
    }
    .boldweight {
      font-family: 'FuturaPTHeavy';
      font-weight: 900;
      letter-spacing: 0.03em;
    }

    .uyh-back {
      padding: 55px 0 14.5px;
      position: relative;
    }

    .uyh-additional-controls {
      align-items: center;
      display: flex;
      justify-content: center;
      margin-top: 40px;
      > * {
        margin: 0 25px;
      }
      .resetMantra {
        cursor: pointer;
        font-size: 20px;
        &:after {
          background-color: #223628;
          content: '';
          display: block;
          height: 2px;
          position: relative;
          width: 100%;
        }
      }
    }

    .uyh-text-design-container {
      flex: 1 0 68.75%;
      padding: 0 0 40px 0;
      width: 68.75%;
      @media screen and (max-width: 1199px) {
        padding: 40px 0;
      }
      @media screen and (max-width: 767px) {
        padding: 0;
      }
    }

    .uyh-background {
      &.primary {
        width: 640px;

        h1 {
          margin: 0;
        }

        &.temp-1 {
          h1 {
            font-size: 90px;
          }

          .uyh-hashtag,
          svg {
            left: 50%;
            position: absolute;
            transform: translateX(-50%);
          }
          .uyh-hashtag {
            top: 10%;
          }
          svg {
            bottom: 10%;
          }

          @media screen and (max-width: $hd-desktop-breakpoint) {
            h1 {
              font-size: calc(90px * 450 / 640);
            }
          }
          @media screen and (max-width: $mobile-breakpoint) {
            h1 {
              font-size: 60px;
            }
          }
        }

        &.temp-2 {
          h1 {
            font-size: 70px;
            line-height: 1.1;
          }

          .uyh-hashtag,
          svg {
            left: 50%;
            position: absolute;
            transform: translateX(-50%);
          }
          .uyh-hashtag {
            top: 10%;
          }
          svg {
            bottom: 10%;
          }

          @media screen and (max-width: $hd-desktop-breakpoint) {
            h1 {
              font-size: calc(70px * 450 / 640);
            }
          }
          @media screen and (max-width: $mobile-breakpoint) {
            h1 {
              font-size: 50px;
            }
          }
        }

        &.temp-3 {
          h1 {
            font-size: 55px;
            line-height: 1.2;
          }

          .uyh-hashtag,
          svg {
            left: 50%;
            position: absolute;
            transform: translateX(-50%);
          }
          .uyh-hashtag {
            top: 10%;
          }
          svg {
            bottom: 10%;
          }

          @media screen and (max-width: $hd-desktop-breakpoint) {
            h1 {
              font-size: calc(55px * 450 / 640);
            }
          }
          @media screen and (max-width: $mobile-breakpoint) {
            h1 {
              font-size: 40px;
            }
          }
        }

        &.temp-4 {
          h1 {
            font-size: 77px;
          }

          .uyh-hashtag,
          svg {
            left: 50%;
            position: absolute;
            transform: translateX(-50%);
          }
          .uyh-hashtag {
            top: 10%;
          }
          svg {
            bottom: 10%;
          }

          @media screen and (max-width: $hd-desktop-breakpoint) {
            h1 {
              font-size: calc(77px * 450 / 640);
            }
          }
          @media screen and (max-width: $mobile-breakpoint) {
            h1 {
              font-size: 57px;
            }
          }
        }

        &.temp-5,
        &.temp-6 {
          .textarea {
            box-shadow: none;
            height: 100%;
            padding: 0;
            width: 100%;
            .uyh-hashtag,
            svg {
              left: 50%;
              position: absolute;
              transform: translateX(-50%);
            }
            .uyh-hashtag {
              top: 40px;
            }
            svg {
              bottom: 40px;
            }
          }

          h1 {
            font-size: 85px;
            line-height: 1.3;
            padding: 10px 15px;
          }
          @media screen and (max-width: $hd-desktop-breakpoint) {
            h1 {
              font-size: calc(85px * 450 / 640);
            }
          }
          @media screen and (max-width: $mobile-breakpoint) {
            h1 {
              font-size: 55px;
            }
          }
        }

        &.temp-7 {
          .textarea {
            box-shadow: none;
            height: 100%;
            padding: 0;
            width: 100%;
            .uyh-hashtag,
            svg {
              left: 50%;
              position: absolute;
              transform: translateX(-50%);
            }
            .uyh-hashtag {
              top: 40px;
            }
            svg {
              bottom: 40px;
            }
          }

          h1 {
            font-size: 65px;
            line-height: 1;
            padding: 10px 15px;
          }
          @media screen and (max-width: $hd-desktop-breakpoint) {
            h1 {
              font-size: calc(65px * 450 / 640);
            }
          }
          @media screen and (max-width: $mobile-breakpoint) {
            h1 {
              font-size: 40px;
            }
          }
        }

        &.temp-8 {
          .uyh-hashtag,
          svg {
            left: 50%;
            position: absolute;
            transform: translateX(-50%);
          }
          .uyh-hashtag {
            top: 40px;
          }
          svg {
            bottom: 40px;
          }

          .textarea {
            height: 250px;
            padding: 0;
            width: 250px;

            .message-wrapper {
              align-items: center;
              display: flex;
              height: 100%;
              margin: 0 auto;
              h1{
                flex: 1 0 100%;
                margin: 0;
              }
            }
          }

          h1 {
            font-size: 42px;
            line-height: 1.1;
          }

          @media screen and (max-width: $hd-desktop-breakpoint) {
            .textarea {
              height: calc(250px * 450 / 640);
              width: calc(250px * 450 / 640);
            }
            h1 {
              font-size: calc(42px * 450 / 640);
            }
            .uyh-hashtag {
              top: 22px;
            }
            svg {
              bottom: 15px;
            }
          }
          @media screen and (max-width: $mobile-breakpoint) {
            h1 {
              font-size: 25px;
            }
          }
        }

        &.temp-9,
        &.temp-10 {
          .textarea {
            height: 250px;
            padding: 0;
            width: 250px;

            .message-wrapper {
              align-items: center;
              display: flex;
              flex-wrap: wrap;
              height: 100%;
              margin: 0 auto;
              h1 {
                flex: 1 0 100%;
                line-height: 1.1;
                margin: 0;
              }
              .uyh-hashtag,
              svg {
                left: 50%;
                position: absolute;
                transform: translateX(-50%);
              }
              .uyh-hashtag {
                top: 16px;
              }
              svg {
                bottom: 12px;
              }
            }
          }

          h1 {
            font-size: 35px;
          }
          @media screen and (max-width: $hd-desktop-breakpoint) {
            .textarea {
              height: calc(250px * 450 / 640);
              width: calc(250px * 450 / 640);
              svg {
                width: calc(34px * 450 / 640);
              }
            }
            h1 {
              font-size: calc(35px * 450 / 640);
            }
          }
          @media screen and (max-width: $mobile-breakpoint) {
            h1 {
              font-size: 20px;
            }
          }
        }

        &.temp-10 {
          .textarea {
            .message-wrapper {
              svg {
                bottom: 16px;
                @media screen and (max-width: $hd-desktop-breakpoint) {
                  bottom: 8px;
                }
              }
            }
          }
        }

        &.temp-11 {
          .secondary {
            box-shadow: none;
            height: 100%;
            transform: translateY(-50%);
            width: 50%;
          }
          .textarea {
            box-shadow: none;
            height: 250px;
            padding: 0;
            width: 250px;
          }
          h1,
          .large-spade {
            left: 50%;
            position: absolute;
            top: 50%;
            transform: translateX(-50%) translateY(-50%);
            width: 100%;
          }

          .large-spade {
            height: 100%;
          }

          .uyh-hashtag,
          svg {
            left: 50%;
            position: absolute;
            transform: translateX(-50%);
          }
          .uyh-hashtag {
            top: 46px;
            z-index: 2;
          }
          svg {
            bottom: 8.5%;
            z-index: 1;
          }

          h1 {
            font-size: 40px;
            transform: translateX(-50%) translateY(-60%);
            z-index: 1;
          }
          @media screen and (max-width: $hd-desktop-breakpoint) {
            h1 {
              font-size: calc(40px * 450 / 640);
            }
          }
          @media screen and (max-width: $mobile-breakpoint) {
            h1 {
              font-size: 20px;
              transform: translateX(-50%) translateY(-53%);
            }
            .textarea {
              height: 200px;
              width: 200px;
            }
          }
        }

        &.temp-12 {
          .secondary {
            box-shadow: none;
            height: 100%;
            transform: translateY(-50%);
            width: 50%;
          }

          .textarea {
            box-shadow: none;
            height: 100%;
            padding: 0;
            .uyh-hashtag,
            svg {
              left: 50%;
              position: absolute;
              transform: translateX(-50%);
            }
            .uyh-hashtag {
              top: 40px;
            }
            svg {
              bottom: 40px;
              z-index: 1;
            }
          }
          h1 {
            font-size: 75px;
          }
          @media screen and (max-width: $hd-desktop-breakpoint) {
            h1 {
              font-size: calc(75px * 450 / 640);
            }
          }
          @media screen and (max-width: $mobile-breakpoint) {
            h1 {
              font-size: 50px;
            }
          }
        }
      }
    }

    @media screen and (min-width: $tablet-portrait-breakpoint) and (max-width: $hd-desktop-breakpoint) {
      .uyh-back {
        padding: 14.5px 0;
      }
      .uyh-background {
        &.primary {
          max-width: 75vh;
          min-width: 450px;
        }
      }
      .uyh-additional-controls {
        margin-top: 31px;
        .uyh-btn {
          height: 40px;
          line-height: 40px;
        }
      }
    }

    @media screen and (max-width: $tablet-down-breakpoint) {
      .uyh-back {
        padding: 0;
        position: absolute;
      }
      .uyh-background {
        &.primary {
          max-width: calc(100vh - 298px);
          min-width: 400px;
        }
      }
    }

    @media screen and (max-width: $tablet-portrait-down-breakpoint) {
      .uyh-background {
        &.textarea {
          &.temp-3 {
            h1 {
              font-size: 60px;
            }
          }
          &.temp-7 {
            h1 {
              font-size: 60px;
            }
          }
        }
      }
    }

    @media screen and (max-width: $mobile-breakpoint) {
      .uyh-text-design-container {
        flex: 0 0 auto;
        width: 100%;
      }

      .uyh-background {
        &.primary {
          left: 50%;
          margin: 0;
          min-width: 400px;
          position: relative;
          transform: translateX(-50%);
          width: 100%;
        }
      }
    }
  }
</style>
